import { render, staticRenderFns } from "./OrderClaimInventory.vue?vue&type=template&id=fcee1f6e&"
import script from "./OrderClaimInventory.vue?vue&type=script&lang=ts&"
export * from "./OrderClaimInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports